class SubcollectionBubblesCarousel extends HTMLElement {
  constructor() {
    super();
    this.handleResize = this.updateStyles.bind(this);
    this.handleScroll = this.updateBtnState.bind(this);

    this.handlePrevClick = this.clickPrev.bind(this);
    this.handleNextClick = this.clickNext.bind(this);
    this.handleControlNext = this.finishOnNext.bind(this);

    this.resizeObserver = null;
  }

  connectedCallback() {
    this.carousel = this.querySelector(".subcollections__wrapper-carousel");
    if (!this.carousel) return;

    // native carousel buttons
    this.prev = this.querySelector(".prev-next-button--prev.native");
    this.next = this.querySelector(".prev-next-button--next.native");

    this.updateStyles();

    if (this.prev && this.next) this.updateBtnState();

    window.addEventListener("resize", this.handleResize);
    document.addEventListener("shopify:section:load", this.handleResize);

    if (this.prev && this.next) {
      this.carousel.addEventListener("scroll", this.handleScroll, {
        passive: true,
      });
      this.prev.addEventListener("click", this.handlePrevClick);
      this.next.addEventListener("click", this.handleNextClick);
    }

    this.resizeObserver = new ResizeObserver(() => this.updateStyles());
    this.resizeObserver.observe(this.carousel);

    this.addEventListener("control:next", this.handleControlNext, true);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("shopify:section:load", this.handleResize);
    if (this.prev && this.next) {
      this.carousel.removeEventListener("scroll", this.handleScroll);
      this.prev.removeEventListener("click", this.handlePrevClick);
      this.next.removeEventListener("click", this.handleNextClick);
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    this.removeEventListener("control:next", this.handleControlNext, true);
  }

  finishOnNext(event) {
    const carousel = this.carousel;
    if (!carousel || !window.matchMedia("(min-width: 1280px)").matches) return;

    const cards = carousel.querySelectorAll(".subcollections__card");
    if (cards.length < 2) return;

    const stride = cards[1].offsetLeft - cards[0].offsetLeft;
    if (stride <= 0) return;

    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    const current = Math.abs(carousel.scrollLeft);
    if (maxScroll - current <= 1) return;

    const themeTarget = (Math.round(current / stride) + 1) * stride;
    const remaining = maxScroll - Math.min(themeTarget, maxScroll);
    const cardWidth = cards[0].offsetWidth;

    if (remaining <= 1 || remaining > cardWidth) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    carousel.scrollTo({
      left: maxScroll,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  }

  updateBtnState() {
    const scrollLeft = this.carousel.scrollLeft;
    const maxScrollLeft = this.carousel.scrollWidth - this.carousel.clientWidth;
    this.prev.disabled = scrollLeft <= 0;
    this.next.disabled = scrollLeft >= maxScrollLeft - 1;
  }

  clickPrev() {
    if (!this.carousel) return;
    this.carousel.scrollBy({
      left: this.carousel.offsetWidth * -1,
      behavior: "smooth",
    });
  }

  clickNext() {
    if (!this.carousel) return;
    this.carousel.scrollBy({
      left: this.carousel.offsetWidth * 1,
      behavior: "smooth",
    });
  }

  updateStyles() {
    const carousel = this.carousel;
    if (!carousel) return;

    const isMobile = window.matchMedia("(pointer: coarse)").matches;

    if (isMobile) {
      carousel.setAttribute("allow-drag", "");
    } else {
      carousel.removeAttribute("allow-drag");
    }

    if (this.prev && this.next) {
      this.updateBtnState();
    }
  }
}

customElements.define(
  "subcollection-bubbles-carousel",
  SubcollectionBubblesCarousel,
);
